import React from 'react'
import { IconButton, Flex, Text } from '@radix-ui/themes'
import { useLanguage } from '../contexts/LanguageContext'
import { Globe } from 'lucide-react'

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { language, setLanguage, t } = useLanguage()

  const handleLanguageChange = () => {
    const newLang = language === 'en' ? 'ar' : 'en'
    setLanguage(newLang)
  }

  return (
    <Flex align="center" gap="1" style={{ alignItems: 'center' }} className={className}>
      <IconButton
        variant="ghost"
        size="2"
        onClick={handleLanguageChange}
        title={t('switchLanguage')}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        className="text-current hover:bg-black/5 dark:hover:bg-white/10"
      >
        <Globe className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity" />
      </IconButton>
      <Text
        size="2"
        className="hidden sm:inline cursor-pointer opacity-70 hover:opacity-100 transition-opacity"
        onClick={handleLanguageChange}
        style={{ userSelect: 'none', lineHeight: '1.5' }}
      >
        {language === 'en' ? t('arabic') : t('english')}
      </Text>
      <Text
        size="2"
        className="sm:hidden cursor-pointer opacity-70 hover:opacity-100 transition-opacity"
        onClick={handleLanguageChange}
        style={{ userSelect: 'none', lineHeight: '1.5' }}
      >
        {language === 'en' ? 'AR' : 'EN'}
      </Text>
    </Flex>
  )
}

export default LanguageSwitcher
